 import Img from '@/page/mall/setting/Img'
 import Category from '@/page/mall/setting/Category'
 import Evaluation from '@/page/mall/setting/Evaluation'
 import Recommend from '@/page/mall/marketing/Recommend'
 import Sales from '@/page/mall/marketing/Sales'
 import Now from '@/page/mall/marketing/Now'
 import Setting from '@/page/mall/setting'
 export const mall = [
     {
        path: '/mall/Setting/Img',
        name: 'Img',
        component: Img,
        meta: {
          requireAuth: true,
          title: '门店图片'
        },
     },
     {
        path: '/mall/Setting/Category',
        name: 'Category',
        component: Category,
        meta: {
          requireAuth: true,
          title: '分类导航'
        },
     },
     {
        path: '/mall/Setting/Evaluation',
        name: 'Evaluation',
        component: Evaluation,
        meta: {
          requireAuth: true,
          title: '商品评价'
        },
     },
     {
        path: '/mall/marketing/Recommend',
        name: 'Recommend',
        component: Recommend,
        meta: {
          requireAuth: true,
          title: '推荐商品'
        },
     },
     {
        path: '/mall/marketing/Sales',
        name: 'Sales',
        component: Sales,
        meta: {
          requireAuth: true,
          title: '促销商品'
        },
     },
     {
        path: '/mall/marketing/Now',
        name: 'Now',
        component: Now,
        meta: {
          requireAuth: true,
          title: '最新商品'
        },
     },
     {
      path: '/mall/setting',
      name: 'Setting',
      component: Setting,
      meta: {
        requireAuth: true,
        title: '商城设置'
      },
   },
 ]


// WEBPACK FOOTER //
// ./src/router/mall.route.js